import { fetch } from "@insite/client-framework/ServerSideRendering";
import { ApiError, ApiParameter, get, rawRequest, request } from "@insite/client-framework/Services/ApiService";

export interface ImagesZipResultModel {
    result: any;
}

export interface ImagesZipParameter extends ApiParameter {
    imagesURL?: string[];
    brandName?: string;
    productName?: string;
}

export const ImagesZipUrl = "/api/v2/ImagesZip";

export async function ImagesZip(parameter: ImagesZipParameter) {
    const request ={
        imagesURL: parameter.imagesURL,
        brandName: parameter.brandName,
    }
    const response = await fetch(`${ImagesZipUrl}`,{
        method : "POST",
        headers: {
            "Content-Type": "application/json",
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
        body: JSON.stringify(request)
    });

    try {
        const blob = response.ok && (await response.blob());
        if (!response.ok) {
            throw new Error(
                JSON.stringify({
                    status: response.status,
                    errorJson: {
                        message: response.statusText,
                    },
                }),
            );
        }
        return blob;
    } catch (error) {
        let message: string;
        let errorJson: any;
        if (response.headers.get("Content-Type")?.startsWith("application/json")) {
            errorJson = (await response.json()) as { message: string; exceptionMessage?: string };
            message = errorJson.exceptionMessage ?? errorJson.message;
        } else {
            message = await response.text();
        }
        throw new ApiError(ImagesZipUrl, response, message, errorJson);
    }
}
